/* eslint-disable no-undef */
import { useEffect, useState } from 'react';
import { Container, Dropdown, Form, Nav, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { BiUser } from 'react-icons/bi';
import { FaSignOutAlt, FaUserCog } from 'react-icons/fa';
import { IoIosStats } from 'react-icons/io';
import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import UserInfo from '../../Components/UserInfo/UserInfo';
import { handleLocalChange } from '../../Redux/slices/local';
import { logoutUser } from '../../Redux/slices/user';
import NotificationBell from './components/NotificationBell/NotificationBell';
import RoleChanger from './components/RoleChanger';
import { Logo, StyledNavbar, SubTitle, Title, UserDropDown } from './components/styles';

import './style/Header.scss';

function Header({ admin }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector((state) => state.user.user);
  const isLoggedIn = useSelector((state) => state.user.isLoggedIn);
  const local = useSelector((state) => state.local.local);
  const activeRole = useSelector((state) => state.user?.user?.active_role);
  const [active, setActive] = useState(activeRole);
  useEffect(() => {
    setActive(activeRole);
  }, [activeRole]);

  const changeActiveRole = (title) => {
    setActive(title);
  };

  return (
    <StyledNavbar
      bg="light"
      collapseOnSelect
      expand="lg"
      style={{ position: 'sticky', top: '0', zIndex: 6 }}>
      <Container fluid className="d-flex justify-content-between header-container">
        <div>
          <Link to="/">
            <StyledNavbar.Brand>
              <div className="logo d-flex align-items-center">
                <Logo src="/assets/images/logo.webp" alt="logo" className="me-1" />
              </div>
              <div>
                <Title>
                  <FormattedMessage id="government_of_nepal" />
                </Title>
                <Title>
                  <FormattedMessage id="ministry_of_federal_afairs_and_general_administration" />
                </Title>
                <SubTitle>
                  <FormattedMessage id="provincial_and_local_goverment_support_program" />
                </SubTitle>
              </div>
            </StyledNavbar.Brand>
          </Link>
        </div>
        <div>
          {admin ? null : (
            <Nav className="ms-auto">
              <Nav.Link href="#home" className="ml-4 custom-header-link">
                <FormattedMessage id="heading.about" />
              </Nav.Link>
              <a
                className="ml-4 nav-link custom-header-link"
                href={process.env.REACT_APP_KMS}
                target="_blank"
                rel="noreferrer">
                <FormattedMessage id="heading.knowledge_module" />
              </a>

              <Nav.Link href="#events" className="ml-4 custom-header-link">
                <FormattedMessage id="heading.events" />
              </Nav.Link>
              <Nav.Link href="#pricing" className="ml-4 custom-header-link">
                <FormattedMessage id="heading.support" />
              </Nav.Link>
            </Nav>
          )}
        </div>
        <Nav className="heading-controls">
          <div className="d-flex align-items-center">
            {isLoggedIn ? (
              <>
                <UserDropDown className="user-avatar-wrapper">
                  <Dropdown>
                    <Dropdown.Toggle
                      variant="primary"
                      id="dropdown-basic"
                      className="d-flex align-items-center">
                      {user && <UserInfo user={user} role={active} />}
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                      {user?.role?.length > 1 && (
                        <Dropdown.Item as={Link} to="#">
                          <RoleChanger activeRole={active} changeActiveRole={changeActiveRole} />
                        </Dropdown.Item>
                      )}

                      <Dropdown.Item as={Link} to="/admin">
                        <IoIosStats /> <FormattedMessage id="dashboard" />
                      </Dropdown.Item>
                      <Dropdown.Item as={Link} to={`/admin/profile/me`}>
                        <BiUser /> <FormattedMessage id="profile" />
                      </Dropdown.Item>
                      <Dropdown.Item
                        onClick={() => {
                          dispatch(logoutUser());
                          navigate('/');
                        }}>
                        <FaSignOutAlt /> <FormattedMessage id="logout" />
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </UserDropDown>
                <div className="navbar">
                  <ul className="navbar-nav">
                    <li className="nav-item">
                      <OverlayTrigger
                        placement="bottom"
                        delay={{ show: 150, hide: 50 }}
                        overlay={<Tooltip>User Config.</Tooltip>}>
                        <a href="#" className="icon-button">
                          <FaUserCog />
                        </a>
                      </OverlayTrigger>
                    </li>
                    <li className="nav-item">
                      <NotificationBell />
                    </li>
                  </ul>
                </div>
              </>
            ) : (
              ''
              // <div className="d-flex">
              //   <Dropdown className="me-2 ms-5">
              //     <Dropdown.Toggle variant="success" id="dropdown-basic">
              //       Register
              //     </Dropdown.Toggle>

              //     <Dropdown.Menu>
              //       <Dropdown.Item as={Link} to="/rosters/apply">
              //         Register as Resource Person
              //       </Dropdown.Item>
              //       <Dropdown.Item as={Link} to="/trainees/apply">
              //         Register as Participant
              //       </Dropdown.Item>
              //     </Dropdown.Menu>
              //   </Dropdown>

              //   <Button variant="primary" onClick={() => navigate('/signin')}>
              //     Login
              //   </Button>
              // </div>
            )}
            <OverlayTrigger
              placement="bottom"
              delay={{ show: 150, hide: 50 }}
              overlay={<Tooltip>Switch Language</Tooltip>}>
              <Form.Select
                className="icon-button language-switcher"
                onChange={(e) => dispatch(handleLocalChange(e.target.value))}
                defaultValue={local}>
                <option value="en-US">En</option>
                <option value="ne">ने</option>
              </Form.Select>
            </OverlayTrigger>
          </div>
        </Nav>
      </Container>
    </StyledNavbar>
  );
}

export default Header;
